import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { Subscription } from 'rxjs';

@Component({
    selector: 'kiene-gruppen',
    templateUrl: './gruppen.component.html',
    styleUrls: ['./gruppen.component.scss'],
})
export class GruppenComponent implements OnInit, OnDestroy {
    watchClientSubscription: Subscription;

    currentClient: Client;

    constructor(
        private localStorageService: LocalStorageService,
        public router: Router,
    ) {}

    ngOnInit(): void {
        this.localStorageService.setShoppingCartVisible(false, 'GruppenComponent');
        this.currentClient = this.localStorageService.getCurrentClient();
        this.watchClientSubscription = this.localStorageService.watchCurrentClient().subscribe((client: Client) => {
            this.currentClient = client;
        });
    }

    ngOnDestroy() {
        this.watchClientSubscription.unsubscribe();
    }

    // Bei Schweinebetrieb im Gruppenmenu u. a. Uebersicht, Globale Tiersuche deaktivieren.

    isTabDisabled(tab: string) {
        if (
            this.localStorageService.isCurrentClientSchwein() &&
            (tab === 'dashboard' ||
                tab === 'buchungshistorie' ||
                tab === 'abhollisten' ||
                tab === 'globale-suche')
        ) {
            return true;
        }
        return false;
    }

    isTabMenuVisible(path: string) {
        return this.localStorageService.currentUserCanSeeTab(path);
    }

    isPhitoAdmin() {
        return this.localStorageService.isCurrentUserPhitoUser();
    }

    isDashboardTabActive(routerLinkActive: boolean): boolean {
        return routerLinkActive || this.router.url.startsWith('/gruppen/dashboard');
    }

    isTiergruppenTabActive(routerLinkActive: boolean): boolean {
        if (routerLinkActive) {
            return true;
        }
        const url = this.router.url.split('?')[0];
        if (url.startsWith('/gruppen/aktuelle-schwein')) {
            return false;
        }
        return url === '/gruppen/aktuelle' || url.startsWith('/gruppen/aktuelle/');
    }

    isHistorieTabActive(routerLinkActive: boolean): boolean {
        return routerLinkActive || this.router.url.startsWith('/gruppen/historie');
    }

    isTierlistenTabActive(routerLinkActive: boolean): boolean {
        return routerLinkActive || this.router.url.startsWith('/gruppen/tierlisten');
    }

    isGlobaleSucheTabActive(routerLinkActive: boolean): boolean {
        return routerLinkActive || this.router.url.startsWith('/gruppen/globale-suche');
    }

    isHitmeldungenTabActive(routerLinkActive: boolean): boolean {
        return routerLinkActive || this.router.url.startsWith('/gruppen/hitmeldungen');
    }
}
